export const InventoryProviderType = {
  DealerTrend: 1,
  Vauto: 2,
  OfferLogix: 3

}



// WEBPACK FOOTER //
// ./scripts/src/shared/enums/inventory.js